<div class="hamburger-container">
	<div [ngClass]="menu_press_open ? 'icon-clear' : 'icon-menu'"
	     class="icon">
	</div>
	<div [ngClass]="{'visible': menu_hover_open || menu_press_open}"
	     class="text">
		{{ (menu_press_open ? 'Close menu' : 'Keep open') | tt }}
	</div>
</div>
